import dayjs from "dayjs";

export const dateFormat = (date: string): string =>
  dayjs(date).format("DD/MM/YYYY HH:mm");

export const dateOnlyFormat = (date: string): string =>
  dayjs(date).format("DD/MM/YYYY");

export const dateOnlyFormatYY = (date: string): string =>
  dayjs(date).format("DD/MM/YY");

export const getDaysDifference = (
  endDate: string,
  startDate: string
): number => {
  const d2 = new Date(endDate);
  const d1 = new Date(startDate);
  return (d2.getTime() - d1.getTime()) / (1000 * 60 * 60 * 24);
};

export const getDetailsPageDateFormat = (date: string): string =>
  dayjs(date).format("MMMM D, YYYY");

export const pad = (num: number, size = 2): string =>
  String(num).padStart(size, "0");

/**
 * Formats a date string to a localized datetime format.
 * Returns the original string if the date is invalid.
 */
export const formatDateTime = (
  dateString: string,
  locale = "en-GB",
  options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }
): string => {
  const parsed = dayjs(dateString);
  if (!parsed.isValid()) {
    return dateString;
  }
  return parsed.toDate().toLocaleString(locale, options).replaceAll(",", "");
};

export const formatDateTimeISO = (date: string): string =>
  dayjs(date).format("YYYY-MM-DD HH:mm");

export const formatDateToUTCWithTimezone = (date: Date): string => {
  const year = date.getUTCFullYear();
  const month = pad(date.getUTCMonth() + 1);
  const day = pad(date.getUTCDate());

  const hours = pad(date.getUTCHours());
  const minutes = pad(date.getUTCMinutes());
  const seconds = pad(date.getUTCSeconds());

  // Milliseconds with extended precision to 6 digits
  const milliseconds = `${pad(date.getUTCMilliseconds(), 3)}000`;

  // UTC offset is always +00:00 for UTC time
  const timezoneOffset = "+00:00";

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}.${milliseconds}${timezoneOffset}`;
};
